// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__MsrDX","list":"PatternAutocomplete_list__bUdDG"};